type StartupPerfEntry = {
  name: string;
  time: number;
  delta: number;
  data?: Record<string, any>;
};

declare global {
  interface Window {
    __SSG_STARTUP_PERF__?: StartupPerfEntry[];
  }
}

const STORAGE_KEY = 'ssg_startup_perf';
const START_TIME = performance.now();

function isStartupPerfEnabled() {
  const params = new URLSearchParams(window.location.search);
  const isLocal = window.location.hostname === 'localhost'
    || window.location.hostname === '127.0.0.1'
    || window.location.hostname.startsWith('192.168.')
    || window.location.port !== '';

  return params.get('ssgPerf') === '1'
    || params.get('startupPerf') === '1'
    || sessionStorage.getItem(STORAGE_KEY) === '1'
    || localStorage.getItem(STORAGE_KEY) === '1'
    || isLocal; // Auto-enable in local dev browser environments
}

export function markStartupPerf(name: string, data?: Record<string, any>) {
  if (!isStartupPerfEnabled()) return;

  const time = performance.now();
  const entry: StartupPerfEntry = {
    name,
    time,
    delta: time - START_TIME,
    data,
  };

  window.__SSG_STARTUP_PERF__ = window.__SSG_STARTUP_PERF__ || [];
  window.__SSG_STARTUP_PERF__.push(entry);

  // eslint-disable-next-line no-console
  console.log(`[SSG_PERF] ${name} +${entry.delta.toFixed(1)}ms`, data || '');
}

export function printStartupPerfSummary() {
  if (!isStartupPerfEnabled()) return;

  const entries = window.__SSG_STARTUP_PERF__ || [];
  if (!entries.length) return;

  // eslint-disable-next-line no-console
  console.table(entries.map((entry) => ({
    name: entry.name,
    deltaMs: Number(entry.delta.toFixed(1)),
    timeMs: Number(entry.time.toFixed(1)),
    data: entry.data ? JSON.stringify(entry.data) : '',
  })));
}

export function enableStartupPerfForCurrentSession() {
  sessionStorage.setItem(STORAGE_KEY, '1');
}

export function disableStartupPerfForCurrentSession() {
  sessionStorage.removeItem(STORAGE_KEY);
}

